import  gql  from 'graphql-tag'

export const PASSWORD_CHANGE = gql`mutation passwordChange($input: PasswordChangeMutationInput!){
    passwordChange(input: $input){
        errors{
            field
            messages
        }
    }
}`;